import { LocaleStrings } from '../keys';

const th: LocaleStrings = {
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Searchâ€¦',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  nav_stories: 'à¹€à¸£à¸·à¹ˆà¸­à¸‡à¸£à¸²à¸§',
  nav_create: 'à¸ªà¸£à¹‰à¸²à¸‡',
  nav_login: 'à¹€à¸‚à¹‰à¸²à¸ªà¸¹à¹ˆà¸£à¸°à¸šà¸š',

  page_title_main: 'Story Craft - à¸«à¸™à¹‰à¸²à¸«à¸¥à¸±à¸',
  section_browse_by_category: 'à¹€à¸£à¸µà¸¢à¸à¸”à¸¹à¸•à¸²à¸¡à¸«à¸¡à¸§à¸”à¸«à¸¡à¸¹à¹ˆ',
  section_explore_new_games: 'à¸ªà¸³à¸£à¸§à¸ˆà¹€à¸à¸¡à¹ƒà¸«à¸¡à¹ˆ',
  section_popular: 'à¸¢à¸­à¸”à¸™à¸´à¸¢à¸¡',
  section_trending: 'à¸à¸³à¸¥à¸±à¸‡à¸¡à¸²à¹à¸£à¸‡',
  section_trending_now: 'กำลังมาแรง',
  section_popular_picks: 'ยอดนิยม',
  section_recent_stories: 'à¹€à¸£à¸·à¹ˆà¸­à¸‡à¸—à¸µà¹ˆà¸”à¸¹à¸¥à¹ˆà¸²à¸ªà¸¸à¸”',
  section_new_stories: 'à¹€à¸£à¸·à¹ˆà¸­à¸‡à¹ƒà¸«à¸¡à¹ˆ',
  btn_load_more_games: 'à¹‚à¸«à¸¥à¸”à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡ (à¸­à¸µà¸ {count} à¹€à¸à¸¡)',
  text_showing_games: 'à¹à¸ªà¸”à¸‡ {visible} à¸ˆà¸²à¸ {total} à¹€à¸à¸¡',
  text_no_category_games: 'à¹„à¸¡à¹ˆà¸žà¸šà¹€à¸à¸¡ {category}',
  text_category_games: 'à¹€à¸à¸¡ {category}',
  text_error_loading_games: 'à¹€à¸à¸´à¸”à¸‚à¹‰à¸­à¸œà¸´à¸”à¸žà¸¥à¸²à¸”à¹ƒà¸™à¸à¸²à¸£à¹‚à¸«à¸¥à¸”à¹€à¸à¸¡: {error}',

  tell_us_tagline: 'Story Craft: à¸—à¸µà¹ˆà¸‹à¸¶à¹ˆà¸‡à¹à¸Ÿà¸™à¸Ÿà¸´à¸„à¸Šà¸±à¹ˆà¸™à¸à¸¥à¸²à¸¢à¹€à¸›à¹‡à¸™à¹€à¸£à¸·à¹ˆà¸­à¸‡à¸£à¸²à¸§à¸—à¸µà¹ˆà¹€à¸¥à¹ˆà¸™à¹„à¸”à¹‰',
  tell_us_subtitle: 'à¹€à¸£à¸´à¹ˆà¸¡à¹€à¸à¸¡à¸‚à¸­à¸‡à¸„à¸¸à¸“à¸§à¸±à¸™à¸™à¸µà¹‰!',
  btn_create_now: 'à¸ªà¸£à¹‰à¸²à¸‡à¹€à¸¥à¸¢',

  section_comments: 'à¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™ ({count})',
  text_no_comments: 'à¸¢à¸±à¸‡à¹„à¸¡à¹ˆà¸¡à¸µà¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™ à¹€à¸›à¹‡à¸™à¸„à¸™à¹à¸£à¸à¸—à¸µà¹ˆà¹à¸šà¹ˆà¸‡à¸›à¸±à¸™à¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¸‚à¸­à¸‡à¸„à¸¸à¸“!',
  btn_load_more_comments: 'à¹‚à¸«à¸¥à¸”à¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡',
  text_posting_comment: 'à¸à¸³à¸¥à¸±à¸‡à¹‚à¸žà¸ªà¸•à¹Œà¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™...',
  text_failed_load_comments: 'à¹„à¸¡à¹ˆà¸ªà¸²à¸¡à¸²à¸£à¸–à¹‚à¸«à¸¥à¸”à¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™à¹„à¸”à¹‰',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'à¹„à¸¡à¹ˆà¸žà¸šà¹€à¸à¸¡ - Story Craft',
  page_title_game_info: 'à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸à¸¡ - Story Craft',
  btn_play_now: 'à¹€à¸¥à¹ˆà¸™à¹€à¸¥à¸¢',
  btn_rate: 'à¹ƒà¸«à¹‰à¸„à¸°à¹à¸™à¸™',
  section_about: 'à¹€à¸à¸µà¹ˆà¸¢à¸§à¸à¸±à¸š',
  section_tags: 'à¹à¸—à¹‡à¸',
  text_views: '{count} à¸„à¸£à¸±à¹‰à¸‡à¸—à¸µà¹ˆà¸”à¸¹',
  text_your_rating: 'à¸„à¸°à¹à¸™à¸™à¸‚à¸­à¸‡à¸„à¸¸à¸“: {rating} - {title}',
  text_game_id: 'à¸£à¸«à¸±à¸ªà¹€à¸à¸¡: {id}',
  text_no_description: 'à¹€à¸à¸¡à¸™à¸µà¹‰à¹„à¸¡à¹ˆà¸¡à¸µà¸„à¸³à¸­à¸˜à¸´à¸šà¸²à¸¢',
  text_game_not_found: 'à¹„à¸¡à¹ˆà¸žà¸šà¹€à¸à¸¡',
  text_failed_load_game: 'à¹„à¸¡à¹ˆà¸ªà¸²à¸¡à¸²à¸£à¸–à¹‚à¸«à¸¥à¸”à¸‚à¹‰à¸­à¸¡à¸¹à¸¥à¹€à¸à¸¡à¹„à¸”à¹‰',

  section_similar_games: 'à¹€à¸à¸¡à¸—à¸µà¹ˆà¸„à¸¥à¹‰à¸²à¸¢à¸à¸±à¸™',
  text_failed_load_similar: 'à¹„à¸¡à¹ˆà¸ªà¸²à¸¡à¸²à¸£à¸–à¹‚à¸«à¸¥à¸”à¹€à¸à¸¡à¸—à¸µà¹ˆà¸„à¸¥à¹‰à¸²à¸¢à¸à¸±à¸™à¹„à¸”à¹‰',

  prefooter_btn_start: 'ðŸš€ Start for free',
  prefooter_btn_learn: 'Learn more â†’',

  hero_eyebrow: 'âœ¨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: 'ðŸš€ Start Creating',
  hero_btn_explore: 'ðŸ“– Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  footer_tagline: 'The #1 Interactive Story Creation Platform',

  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'à¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™ Story Craft - à¸–à¸²à¸¡à¹à¸¥à¸°à¸•à¸­à¸šà¸—à¸µà¹ˆà¸™à¸µà¹ˆ',

  section_featured: 'Story Craft à¹à¸™à¸°à¸™à¸³',
  section_top_genre: 'Top à¹€à¸£à¸·à¹ˆà¸­à¸‡{genre}',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating storyâ€¦',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing contentâ€¦',
  translate_progress_step_generate: 'Generating translationsâ€¦',
  translate_progress_step_pack: 'Updating language packâ€¦',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogueâ€¦',
  translate_progress_flavor_2: 'Translating character linesâ€¦',
  translate_progress_flavor_3: 'Converting choicesâ€¦',
  translate_progress_flavor_4: 'Syncing tone of voiceâ€¦',
  translate_progress_flavor_5: 'Proofreadingâ€¦',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',
  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',
  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',
  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  rating_warn_title: 'เรต {rating}',
  rating_warn_teen_body: 'เรื่องนี้ได้รับการจัดเรต T (วัยรุ่น 13+) อาจมีความรุนแรงเล็กน้อย เนื้อหาที่บอกเป็นนัย หรือเนื้อหาที่ไม่เหมาะสมสำหรับผู้อ่านวัยเยาว์',
  rating_warn_mature_body: 'เรื่องนี้ได้รับการจัดเรต M (ผู้ใหญ่ 18+) อาจมีความรุนแรงสูง เนื้อหาสำหรับผู้ใหญ่ หรือเนื้อหาที่มุ่งหมายสำหรับผู้อ่านที่เป็นผู้ใหญ่เท่านั้น',
  rating_warn_continue: 'ดำเนินการต่อ',
  rating_warn_go_back: 'กลับไป',
  rating_warn_confirm_teen: 'ฉันยืนยันว่าฉันอายุ 13 ปีขึ้นไป',
  rating_warn_confirm_mature: 'ฉันยืนยันว่าฉันอายุ 18 ปีขึ้นไป',

  rating_section_title: 'การจัดเรตเนื้อหา',
  rating_label_e: 'ทุกวัย',
  rating_label_t: 'วัยรุ่น 13+',
  rating_label_m: 'ผู้ใหญ่ 18+',
  rating_desc_e: 'เหมาะสำหรับผู้อ่านทุกวัย เนื้อหาเหมาะสำหรับทุกคน',

  hero_dialog_1: 'แฮร์รี่ พอตเตอร์เผลอร่ายมนตร์ผิดใส่เรื่องราวของคุณอีกแล้ว',
  hero_dialog_2: 'เชเฮราซาดยังคงเล่าเรื่องสุดท้ายให้มินาฟังก่อนรุ่งอรุณ…',
  hero_dialog_3: 'เชอร์ล็อก โฮล์มส์พบ plot hole ที่หายไปและปฏิเสธที่จะโหลดต่อ',
  hero_dialog_4: 'แดร็กคิวล่ากำลังรอรับอนุญาตเพื่อเข้าสู่บทที่ 2',
  hero_dialog_5: 'โฟรโดไม่รู้ยังไงทำไฟล์เซฟของคุณตกลงไปในภูเขา Doom',
  hero_dialog_6: 'แฮร์รี่ พอตเตอร์และมินากำลังเถียงกันว่าใครทำให้ timeline พังทลาย',
  hero_dialog_7: 'ซินเดอเรลล่าพลาดเที่ยงคืนอีกครั้ง เลยทำให้หน้าจอโหลดยาวขึ้น',
  hero_dialog_8: 'โรมิโอและจูเลียตมาถึง bad ending ของคุณเร็วไปนิดหน่อย',
  hero_dialog_9: 'อลิซเปิดรูกระต่ายผิดรูและหลงเข้าไปในโฟลเดอร์ draft ของคุณ',
  hero_dialog_10: 'มินาสัญญาว่าจะไม่อ่านหนังสือต้องห้ามอีกแล้ว มินาโกหก',
  hero_dialog_11: 'เมอร์ลินกำลังแก้ไข bug เวทมนตร์ในเครื่องยนต์เรื่องราว',
  hero_dialog_12: 'โอดิสซิอุสพยายามไปถึงบทต่อไปมาสิบปีแล้ว',
  hero_dialog_13: 'ดร. แฟรงเกนสไตน์แตะ codebase เข้าแล้ว ตอนนี้ไม่มีใครรู้สึกปลอดภัยอีกต่อไป',
  hero_dialog_14: 'ปีเตอร์ แพนปฏิเสธที่จะให้เรื่องราวนี้เติบโต',
  hero_dialog_15: 'เจ้าชายน้อยถามมินาว่าทำไมผู้ใหญ่ถึงชอบเขียน tragic ending มากมาย',
};
export default th;
